<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke :selectorPermissions="selectorPermissions" v-on:osvezitevIzbranihPodatkovStranke="GetSap"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine" v-if="izbranSap !== null">
        <div class="odmik-naslova">
          <p class="open-sans-30pt">
            Pregled telefonskih številk
          </p>
        </div>
        <el-tabs type="border-card" class="velikost-el-tabs" @tab-click="HandleTabClick" value="t1" :value="activetab">
          <el-tab-pane label="Osnovni pregled" name="t1" ref="t1" v-if="pokaziOsnovniPregled" class="odmik-mobile">
            <div v-if="activetab === 't1'">
              <div class="odmik-izbirnika" v-if="typeof telefonskeStevilkeStrankeAsoc[izbranSap] !== 'undefined'">
                <div style="width: 100%">
                  <div style="padding-top: 15px">
                    <p>
                      Mesec
                      <el-select v-model="izbranMesec" class="odmik velikost-selecta">
                        <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                                   :value="mesecLeto.val"
                                   :key="mesecLeto.val"
                                   :label="mesecLeto.si_str">
                          {{ mesecLeto.si_str }}
                        </el-option>
                      </el-select>
                    </p>
                  </div>
                </div>
                <OsnovniPregled v-if="izbranSap !== null"
                                :izbranSap="izbranSap"
                                :izbranMesec="izbranMesec"
                                v-on:osveziStranPregledaPorabe="MetodaOsveziIzbranoStevilko"
                                :activetab="activetab"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="Povzetek porabe"
            name="t2"
            :lazy="true"
            ref="t2"
            class="povzetek odmik-mobile"
            v-if="telefonskaStevilka !== ''">
            <div v-if="activetab === 't2'">
              <div class="odmik-izbirnika"
                   v-if="typeof telefonskeStevilkeStrankeAsoc[izbranSap] !== 'undefined'">
                <div>
                  <div v-if="this.seznamStroskovnihNosilcev.length > 1"
                       style="padding-top: 15px"
                       class="flex-container">
                    <div class="nosilec">
                      <p>
                        <span class="odmik-mobile">
                           Stroškovni nosilec
                        </span>
                        <el-select v-model="idStroskovniNosilec" class="odmik velikost-selecta custom-input">
                          <el-option v-for="nosilec in seznamStroskovnihNosilcev"
                                     :value="nosilec.id_expense_account"
                                     :label="nosilec.naziv"
                                     :key="nosilec.id_expense_account">
                          </el-option>
                        </el-select>
                      </p>
                    </div>
                    <div>
                      <p>
                        <span class="odmik-mobile">
                          Telefonska številka
                        </span>
                        <el-select
                          value-key="telefonska_stevilka"
                          v-model="telefonskaStevilka"
                          placeholder="Izberite tel. številko"
                          class="odmik velikost-selecta custom-input"
                          :disabled="seznamTelefonskih.length === 0"
                          filterable>
                          <el-option-group
                            v-for="grupa in seznamTelefonskihGrupirano"
                            :key="grupa.label"
                            :label="grupa.label">
                            <el-option
                              v-for="(data, key) in grupa.seznamTelStevilk"
                              :value="(typeof data.msisdn !== 'undefined') ? data.msisdn : data"
                              :key="key"
                              :label="VrniFormatiranoTelefonsko(getPhoneNumber(data), data.tip_stevilke || data.idTip.toString())">
                            </el-option>
                          </el-option-group>
                        </el-select>
                      </p>
                    </div>
                    <div>
                      <p>
                        <span class="odmik-mobile">
                          Mesec
                        </span>
                        <el-select v-model="izbranMesec"
                                   @change="PosodobiIzbiro"
                                   class="odmik velikost-selecta"
                                   :disabled="seznamTelefonskih.length === 0">
                          <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                                     :value="mesecLeto.val"
                                     :key="mesecLeto.val"
                                     :label="mesecLeto.si_str">
                            {{ mesecLeto.si_str }}
                          </el-option>
                        </el-select>
                      </p>
                    </div>
                  </div>
                  <div v-else style="padding-top: 15px" class="flex-container">
                    <div>
                      <p>
                        Telefonska številka
                        <el-select
                          value-key="telefonska_stevilka"
                          v-model="telefonskaStevilka"
                          placeholder="Izberite tel. številko"
                          class="odmik velikost-selecta custom-input"
                          :disabled="seznamTelefonskih.length === 0"
                          filterable>
                          <el-option-group
                            v-for="grupa in seznamTelefonskihGrupirano"
                            :key="grupa.label"
                            :label="grupa.label">
                            <el-option
                              v-for="(data, idx) in grupa.seznamTelStevilk"
                              :value="(typeof data.msisdn !== 'undefined') ? data.msisdn : data"
                              :key="`tel-option-${data.telefonska_stevilka}-${idx}`"
                              :label="VrniFormatiranoTelefonsko(
                                     data.telefonska_stevilka || data.msisdn,
                                     data.tip_stevilke || data.idTip.toString()
                                     )">
                            </el-option>
                          </el-option-group>
                        </el-select>
                      </p>
                    </div>
                    <div>
                      <p>
                        Mesec
                        <el-select v-model="izbranMesec"
                                   @change="PosodobiIzbiro"
                                   class="odmik velikost-selecta"
                                   :disabled="seznamTelefonskih.length === 0">
                          <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                                     :value="mesecLeto.val"
                                     :key="mesecLeto.val"
                                     :label="mesecLeto.si_str">
                            {{ mesecLeto.si_str }}
                          </el-option>
                        </el-select>
                      </p>
                    </div>
                  </div>
                </div>
                <Povzetek :izbranSap="izbranSap"
                          :seznamTelefonskihStevilkUmts="seznamTelefonskihStevilkUmts"
                          :telefonskeStevilkeStrankeAsoc="telefonskeStevilkeStrankeAsoc"
                          :telefonskaStevilka="telefonskaStevilka"
                          :izbranMesec="izbranMesec"
                          :idStroskovniNosilec="idStroskovniNosilec"
                          :izbranid="izbranid"
                          :idPrikljucek="idPrikljucek"
                          :osvezitevStevec="osvezitevStevec"
                          :stevecPoizvedb="stevecPoizvedb"
                          :activetab="activetab"
                          v-if="Object.keys(telefonskeStevilkeStrankeAsoc).length > 0" />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Dnevnik" name="t3" ref="t3" class="povzetek odmik-mobile" v-if="telefonskaStevilka !== ''">
            <div v-if="activetab === 't3'">
              <div class="odmik-izbirnika"
                   v-if="typeof telefonskeStevilkeStrankeAsoc[izbranSap] !== 'undefined'">
                <div v-if="this.seznamStroskovnihNosilcev.length > 1" style="padding-top: 15px" class="flex-container">
                  <div>
                    <p>
                      <span class="odmik-mobile">
                        Stroškovni nosilec
                      </span>
                      <el-select v-model="idStroskovniNosilec" class="odmik velikost-selecta custom-input">
                        <el-option v-for="nosilec in seznamStroskovnihNosilcev"
                                   :value="nosilec.id_expense_account"
                                   :label="nosilec.naziv"
                                   :key="nosilec.id_expense_account">
                        </el-option>
                      </el-select>
                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="odmik-mobile">
                        Telefonska številka
                      </span>
                      <el-select
                        value-key="telefonska_stevilka"
                        v-model="telefonskaStevilka"
                        placeholder="Izberite tel. številko"
                        class="odmik velikost-selecta custom-input"
                        :disabled="seznamTelefonskih.length === 0"
                        filterable>
                        <el-option-group
                          v-for="grupa in seznamTelefonskihGrupirano"
                          :key="grupa.label"
                          :label="grupa.label">
                          <el-option
                            v-for="(data, idx) in grupa.seznamTelStevilk"
                            :value="(typeof data.msisdn !== 'undefined') ? data.msisdn : data"
                            :key="`tel-option-${data.telefonska_stevilka}-${idx}`"
                            :label="VrniFormatiranoTelefonsko(getPhoneNumber(data),data.tip_stevilke || data.idTip.toString())">
                          </el-option>
                        </el-option-group>
                      </el-select>

                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="odmik-mobile">
                        Mesec
                      </span>
                      <el-select v-model="izbranMesec" class="odmik velikost-selecta"
                                 :disabled="seznamTelefonskih.length === 0">
                        <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                                   :value="mesecLeto.val"
                                   :key="mesecLeto.val"
                                   :label="mesecLeto.si_str">
                          {{ mesecLeto.si_str }}
                        </el-option>
                      </el-select>
                    </p>
                  </div>
                </div>
                <div v-else style="padding-top: 15px" class="flex-container">
                  <div>
                    <p>
                      Telefonska številka
                      <el-select
                        value-key="telStevilka"
                        v-model="telefonskaStevilka"
                        placeholder="Izberite tel. številko"
                        class="odmik velikost-selecta custom-input"
                        :disabled="seznamTelefonskih.length === 0"
                        filterable>
                        <el-option-group
                          v-for="grupa in seznamTelefonskihGrupirano"
                          :key="grupa.label"
                          :label="grupa.label">
                          <el-option
                            v-for="(data, idx) in grupa.seznamTelStevilk"
                            :value="(typeof data.msisdn !== 'undefined') ? data.msisdn : data"
                            :key="`tel-option-${data.telefonska_stevilka}-${idx}`"
                            :label="VrniFormatiranoTelefonsko(
                                      data.telefonska_stevilka || data.msisdn,
                                     data.tip_stevilke || data.idTip.toString()
                                     )">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </p>
                  </div>
                  <div>
                    <p>
                      Mesec
                      <el-select v-model="izbranMesec"
                                 @change="PosodobiIzbiro"
                                 class="odmik velikost-selecta">
                        <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                                   :value="mesecLeto.val"
                                   :key="mesecLeto.val"
                                   :label="mesecLeto.si_str">
                          {{ mesecLeto.si_str }}
                        </el-option>
                      </el-select>
                    </p>
                  </div>
                </div>
                <Dnevnik :izbranSap="izbranSap"
                         :telefonskaStevilka="telefonskaStevilka"
                         :izbranMesec="izbranMesec"
                         :idStroskovniNosilec="idStroskovniNosilec"
                         :izbranid="izbranid"
                         :idPrikljucek="idPrikljucek"
                         v-if="seznamTelefonskih.length > 0"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="Stroškovni pregled"
            name="t4"
            ref="t4"
            v-if="seznamStroskovnihNosilcev.length > 1"
            class="odmik-mobile">
            <div v-if="activetab === 't4'">
              <div v-if="typeof telefonskeStevilkeStrankeAsoc[izbranSap] !== 'undefined'">
                <div class="odmik-izbirnika">
                  <div style="padding-top: 15px">
                    <p>
                      Mesec
                      <el-select v-model="izbranMesec" class="odmik velikost-selecta custom-input">
                        <el-option v-for="mesecLeto in seznamMoznihMesecLet"
                                   :value="mesecLeto.val"
                                   :key="mesecLeto.val"
                                   :label="mesecLeto.si_str">
                          {{ mesecLeto.si_str }}
                        </el-option>
                      </el-select>
                    </p>
                  </div>
                </div>
                <StroskovniPregled :izbranSapParam="izbranSap"
                                   :izbranMesecParam="izbranMesec"
                                   :izbranid="izbranid"
                                   :seznamStroskovnihNosilcev="seznamStroskovnihNosilcev"/>
              </div>
            </div>
          </el-tab-pane>
<!--          <el-tab-pane label="Meja porabe" name="t5" ref="t5" v-if="seznamTelefonskihStevilkUmts.length > 0">
            <div v-if="activetab === 't5'">
              <div v-if="typeof telefonskeStevilkeStrankeAsoc[izbranSap] !== 'undefined'">
                <MejaPorabe :idPrikljucek="idPrikljucek"
                            :seznamTelefonskihStevilkUmts="seznamTelefonskihStevilkUmts"
                            :seznamTelefonskihGrupirano="seznamTelefonskihGrupirano"
                            :telefonskaStevilkaStranke="telefonskaStevilkaStranke"/>
              </div>
            </div>
          </el-tab-pane>-->
        </el-tabs>
        <div class="odmik-hr">
          <hr class="hr-stil"/>
        </div>
        <div class="odmik-komponente">
          <KomponentaPorabeTelefonijeAplikacije/>
        </div>
        <div v-if="activetab === 't2' || activetab === 't1'" class="odmik-dodatno-obvestilo-povzetek">
          <div>
            <hr class="hr-stil nova-crta">
          </div>
          <div class="opozorilo-klici">
            <div class="odmik-naslova">
              <p class="open-sans-20pt">
                Opombe
              </p>
            </div>
            <el-icon class="el-icon-info" style="padding-top:5px">
            </el-icon>
            <span class="opozorilo-mobile link-bottom">
              Izpis klicev, sporočil, prenosa podatkov in porabe so informativne narave,
              zgodovino vseh številk beležimo za zadnje 3 mesece, cene so v evrih in natančne do četrte decimalke.
              Uporabnikom omogočamo uporabo mobilnih storitev v državah Evropske unije po pogojih in cenah kot doma
              ter v skladu s pogoji posameznega naročniškega paketa. Količini porabljenega podatkovnega prenosa v EU
              in domačem omrežju se seštevata do zakupljene količine, ki jo paket vsebuje. Več informacij o
              gostovanju v EU in zaračunavanju pribitkov boste našli
              <a :href="povezavaEuGostovanjePovezava" class="primarna-barva" target="_blank">tukaj</a>.
              V primeru, da imate na priključku zakupljene enote, velja, da je enota 1 minuta pogovora ali MMS/SMS
              sporočilo v vsa slovenska telekomunikacijska omrežja ali 1 MB prenesenega mobilnega podatkovnega prometa,
              in sicer iz omrežja T-2 ali iz omrežja, pri katerem ima T-2 sklenjeno nacionalno gostovanje.
              Pogoji uporabe mobilnih paketov in uporabe enot so na voljo
              <a :href="povezavaSplosniPogoji" class="primarna-barva" target="_blank">tukaj</a>.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import JsonExcel from 'vue-json-excel'
import Dnevnik from './PorabaTelefonija/Dnevnik.vue'
import MejaPorabe from './PorabaTelefonija/MejaPorabe.vue'
import Povzetek from './PorabaTelefonija/Povzetek.vue'
import OsnovniPregled from './PorabaTelefonija/OsnovniPregled'
import StroskovniPregled from './PorabaTelefonija/StroskovniPregled'
import {MixinGetUserData} from 'src/assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/PridobitevUporabniskihPodatkov.js'
import {PregledNosilcev} from 'src/assets/js/globalne_funkcije/GlobalnoTelefonija/PregledNosilcev.js'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {
  Select, Option, Input, TabPane, Tabs, Alert,
  Button, Tooltip, OptionGroup
} from 'element-ui'
import KomponentaPorabeTelefonijeAplikacije from './PorabaTelefonija/KomponentaPorabeTelefonijeAplikacije'
import {
  FormatirajTelefonskoStevilko
} from '../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke'
import {povezave} from '../../../../assets/js/Povezave/povezave'

Vue.component('downloadExcel', JsonExcel)
export default {
  name: 'PorabaTelefonija',
  mixins: [PregledNosilcev, MixinGetUserData, FormatirajTelefonskoStevilko],
  data () {
    return {
      clientAgent: null,
      seznamMoznihMesecLet: [],
      telefonskeStevilkeStrankeAsoc: {},
      telefonskaStevilka: '',
      idPrikljucek: '',
      izbranMesec: '',
      seznamNarocnin: [],
      izbranSap: null,
      idStroskovniNosilec: null,
      seznamTelefonskih: [],
      seznamStroskovnihNosilcev: [],
      stevecPoizvedb: 0,
      activetab: 't1',
      osvezitevStevec: 0,
      seznamTelefonskihStevilkUmts: [],
      seznamTelefonskihStevilkUmtsAsoc: {},
      telefonskaStevilkaStranke: '',
      izbranid: '',
      selectorPermissions: ['PORABA_TELEFONIJA'],
      pokaziOsnovniPregled: false,
      povezavaSplosniPogoji: null,
      povezavaEuGostovanjePovezava: null,
      seznamTelefonskihGrupirano: []
    }
  },
  components: {
    KomponentaPorabeTelefonijeAplikacije,
    MixinGetUserData,
    'IzbirnikStranke': IzbirnikStranke,
    'Dnevnik': Dnevnik,
    'Povzetek': Povzetek,
    'OsnovniPregled': OsnovniPregled,
    'StroskovniPregled': StroskovniPregled,
    'MejaPorabe': MejaPorabe,
    [Input.name]: Input,
    [Option.name]: Option,
    [Select.name]: Select,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs,
    [Alert.name]: Alert,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [OptionGroup.name]: OptionGroup
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetSeznamNarocnin()
    this.povezavaSplosniPogoji = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
    this.povezavaEuGostovanjePovezava = povezave.BASE_URL_GOSTOVANJE_V_EVROPSKI_UNIJI
  },
  methods: {
    getPhoneNumber (data) {
      return data.telefonska_stevilka || (data.idTip === 1 || data.tip_stevilke === 1 ? data.msisdn : data.telStevilka)
    },
    InitPodatkForme () {
      this.PrikazDatumZaIzbiro()
    },
    MetodaOsveziIzbranoStevilko (izbranaStevilka) {
      this.activetab = 't2'
      this.osvezitevStevec++
      this.telefonskaStevilka = izbranaStevilka
    },
    PosodobiIzbiro () {
      if (this.izbranSap !== null) {
        this.NajdiPrikljucekIzbraneTelefonskeStevilke()
      }
      this.stevecPoizvedb++
    },
    GetSap (podatkiStranke) {
      if (podatkiStranke.id_stranka_sap !== '') {
        this.izbranSap = podatkiStranke.id_stranka_sap
        this.telefonskaStevilkaStranke = podatkiStranke.gsm
        this.OsveziSeznamTelefonskihStevilk()
      }
    },
    GetPorabaGledeNaIzbranStroskovniNosilecInSt () {
      let podatkiNosilca = []
      for (const index in this.seznamStroskovnihNosilcev) {
        if (this.seznamStroskovnihNosilcev[index].id_expense_account === this.idStroskovniNosilec) {
          podatkiNosilca = this.seznamStroskovnihNosilcev[index]['relations']
        }
      }
      this.seznamTelefonskih = []
      if (podatkiNosilca.length === 0) {
        this.OsveziSeznamTelefonskihStevilk()
        this.idStroskovniNosilec = this.seznamStroskovnihNosilcev[0].id_expense_account
        let paramObvestilo = {}
        paramObvestilo.message = 'Nosilec ne vsebuje telefonskih številk.'
        this.ShowWarningMessage(paramObvestilo)
      } else {
        let izbranaStJeVSeznamu = false
        for (let i = 0; i < podatkiNosilca.length; i++) {
          this.seznamTelefonskih.push(podatkiNosilca[i].msisdn)
          if (podatkiNosilca[i].msisdn === this.telefonskaStevilka) {
            izbranaStJeVSeznamu = true
          }
        }
        if (!izbranaStJeVSeznamu) {
          this.telefonskaStevilka = this.seznamTelefonskih.length > 0 ? this.seznamTelefonskih[0] : ''
        }
        this.NajdiPrikljucekIzbraneTelefonskeStevilke()
      }
    },
    ErrNosilecNaSt (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SetSeznamStroskovnihNosilcev (prenosniParametri, seznamStrNos) {
      if (this.izbranid === prenosniParametri.prenesenIzbranId) {
        let seznamStrNosKopija = JSON.parse(JSON.stringify(seznamStrNos))
        let vsiNosilciObj = {id_expense_account: '', naziv: 'Vsi nosilci'}
        Vue.set(vsiNosilciObj, 'relations', [])
        for (const i in seznamStrNosKopija) {
          for (const j in seznamStrNosKopija[i]['relations']) {
            vsiNosilciObj['relations'].push(seznamStrNosKopija[i]['relations'][j])
          }
        }
        seznamStrNos.push(vsiNosilciObj)
        this.seznamStroskovnihNosilcev = seznamStrNos.reverse()
        this.idStroskovniNosilec = this.seznamStroskovnihNosilcev[0].id_expense_account
      }
    },
    PrikazDatumZaIzbiro () {
      this.seznamMoznihMesecLet = []
      let stMesecev = 3
      for (let i = stMesecev - 1; i >= 0; i--) {
        let danes = new Date()
        let d1 = new Date(danes.getFullYear(), danes.getMonth(), 15)
        d1.setMonth(d1.getMonth() - i)
        d1.si_str = d1.toLocaleString('sl-si', {month: 'long'}) + ' ' + d1.getFullYear().toString()
        d1.val = d1.getFullYear() + '-' + (d1.getMonth() + 1)
        this.seznamMoznihMesecLet.push(d1)
      }
      this.izbranMesec = this.seznamMoznihMesecLet[stMesecev - 1].val
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    getTelefonskeAdmin () {
      if (this.izbranSap !== '' && this.izbranSap !== null) {
        let request = {
          permissionId: 'ADMIN_PORABA_TELEFONIJA',
          filter: {
            'sap': this.izbranSap
          }
        }
        return this.clientAgent.makeRequest(
          'permissions/havePermission',
          request,
          'POST'
        )
      }
    },
    async OsveziSeznamTelefonskihStevilk () {
      if (this.izbranSap !== '' && this.izbranSap !== null) {
        let request = {
          permissionId: 'PORABA_TELEFONIJA',
          filter: {
            'sap': this.izbranSap
          }
        }
        let response = await this.clientAgent.makeRequest(
          'permissions/havePermission',
          request,
          'POST'
        )
        if (response.permission.additionalData === null || response.permission.additionalData.length === 0) {
          response = await this.getTelefonskeAdmin()
        }
        this.SetSeznamTelefonskihStevilk(response)
      }
    },
    SetSeznamTelefonskihStevilk (podatki, izbranSap) {
      this.seznamTelefonskihStevilkUmts = []
      this.seznamTelefonskih = []
      this.seznamTelefonskihGrupirano = []
      if (!podatki.permission.additionalData || podatki.permission.additionalData.length === 0) {
        return
      }
      let seznamTelefonskihReverte = []
      for (const element of podatki.permission.additionalData) {
        this.seznamTelefonskihStevilkUmts.push(element)
        seznamTelefonskihReverte.push(element)
        this.DodajVGrupiranSeznam(element)
      }
      this.seznamTelefonskih = seznamTelefonskihReverte.reverse()
      if (this.seznamTelefonskih.length > 0) {
        this.telefonskaStevilka = this.seznamTelefonskih[0].msisdn
      }
      this.seznamTelefonskihStevilkUmtsAsoc[izbranSap] = this.seznamTelefonskihStevilkUmts
      this.NapolniAsocPoljeTelefonskihStevilk(podatki, izbranSap)
      this.SortirajGrupiraneSezname()
    },
    DodajVGrupiranSeznam (element) {
      const labelMob = 'Mobilni priključki'
      const label = Number(element.tip_stevilke) === 1
        ? element.naslovFiksnegaPrikljucka
        : labelMob
      const najdenaSkupina = this.seznamTelefonskihGrupirano.find(x => x.label === label)
      if (najdenaSkupina === undefined) {
        this.seznamTelefonskihGrupirano.push({
          seznamTelStevilk: [element],
          label: label
        })
      } else if (!najdenaSkupina.seznamTelStevilk.includes(element)) {
        najdenaSkupina.seznamTelStevilk.push(element)
      }
    },
    NapolniAsocPoljeTelefonskihStevilk (podatki, izbranSap) {
      if (typeof this.telefonskeStevilkeStrankeAsoc[izbranSap] === 'undefined') {
        Vue.set(this.telefonskeStevilkeStrankeAsoc, izbranSap, {})
      }
      for (const i in podatki.permission.additionalData) {
        const stevilka = podatki.permission.additionalData[i]
        Vue.set(this.telefonskeStevilkeStrankeAsoc[izbranSap], stevilka.msisdn, stevilka)
      }
      if (typeof this.telefonskeStevilkeStrankeAsoc[this.izbranSap] === 'undefined') {
        Vue.set(this.telefonskeStevilkeStrankeAsoc, this.izbranSap, {})
      }
    },
    SortirajGrupiraneSezname () {
      this.seznamTelefonskihGrupirano.sort((a, b) => {
        if (a.label === 'Mobilni priključki') {
          return -1
        }
        if (b.label === 'Mobilni priključki') {
          return 1
        }
        return a.label.localeCompare(b.label)
      })
    },
    NajdiPrikljucekIzbraneTelefonskeStevilke () {
      this.idPrikljucek = ''
      if (typeof this.telefonskeStevilkeStrankeAsoc[this.izbranSap] !== 'undefined' &&
        typeof this.telefonskeStevilkeStrankeAsoc[this.izbranSap][this.telefonskaStevilka] !== 'undefined' &&
        this.telefonskeStevilkeStrankeAsoc[this.izbranSap][this.telefonskaStevilka] !== 'undefined') {
        this.idPrikljucek = this.telefonskeStevilkeStrankeAsoc[this.izbranSap][this.telefonskaStevilka].idPrikljucek
      }
    },
    PosodobiIdStranke () {
      if (this.seznamNarocnin !== null && this.seznamNarocnin.length > 0) {
        for (let i = 0; i < this.seznamNarocnin.length; i++) {
          if (this.seznamNarocnin[i].id_stranka_sap === this.izbranSap) {
            this.izbranid = this.seznamNarocnin[i].id_stranka
            break
          }
        }
      }
    }
  },
  watch: {
    seznamNarocnin: function () {
      this.InitPodatkForme()
    },
    izbranSap: function () {
      if (this.izbranSap !== '' && typeof this.izbranSap !== 'undefined') {
        this.telefonskaStevilka = ''
        this.PosodobiIdStranke()
        this.PrikazDatumZaIzbiro()
        this.pokaziOsnovniPregled = this.HasPermission('NAROCNINE', false, 'id_stranka_sap', this.izbranSap)
        if (!this.pokaziOsnovniPregled) {
          this.activetab = 't2'
        } else {
          this.activetab = 't1'
        }
        let param2 = {}
        param2.vmesnik = this
        param2.prenesenIzbranId = this.izbranid
        this.PridobiNosilce(param2)
        this.OsveziSeznamTelefonskihStevilk()
      }
      this.PosodobiIzbiro()
    },
    idStroskovniNosilec: function () {
      if (this.idStroskovniNosilec !== '') {
        this.GetPorabaGledeNaIzbranStroskovniNosilecInSt()
      }
    },
    telefonskaStevilka: function () {
      this.PosodobiIzbiro()
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Poraba/PorabaTelefonija/PorabaTelefonija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija.vue